
// This needs to be synced with the variable names given to the breakpoints in scss
// See `stylesheets/settings/breakpoints.scss`
export type Breakpoint = typeof breakpoints[number] | undefined

const breakpoints = [480, 600, 768, 960, 1024, 1280, 1440, 1920] as const

export const getBreakpoint = (): Breakpoint => {
  const cssBreakpoint = parseInt(
    window.getComputedStyle(document.body, ':before').getPropertyValue('content').replace(/\"/g, '')
  )
  return breakpoints.find((breakpoint) => breakpoint === cssBreakpoint)
}

export const breakpointSiteheader = (breakpoint: Breakpoint) => breakpoint >= 1024
export const breakpointPageheaderVideo = (breakpoint: Breakpoint) => breakpoint >= 960
